import {
  CalendarClock,
  Archive,
  Car,
  ChevronDown,
  CircleCheck,
  Cog,
  CreditCard,
  FileText,
  MapPin,
  Navigation,
  Search,
  SlidersHorizontal,
  TriangleAlert,
  UserCheck,
  UserMinus,
  UserX,
  WifiOff,
  Wrench,
} from 'lucide-react';

export const VEHICLE_FILTER_ICONS = {
  active: Navigation,
  available: CircleCheck,
  inMaintenance: Wrench,
  maintenanceStatus: Cog,
  noDriver: UserX,
  withAlerts: TriangleAlert,
  trackingAbsent: WifiOff,
  contractExpiring: CalendarClock,
};

export const DRIVER_FILTER_ICONS = {
  active: UserCheck,
  suspended: TriangleAlert,
  inactive: UserMinus,
  archived: Archive,
  noVehicle: Car,
  noFuelCard: CreditCard,
  documentsSoon: FileText,
  estimatedPositionReady: MapPin,
};

export const FILTER_UI_ICONS = {
  search: Search,
  chevronDown: ChevronDown,
  sliders: SlidersHorizontal,
};
